import { useState, useCallback } from "react";

export const useSpeakingRecording = () => {
  const [recordedAudioFile, setRecordedAudioFile] = useState(null);
  const [recordedBlobFile, setRecordedBlobFile] = useState(null);
  const [transcript, setTranscript] = useState("");
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);

  const handleRecordedBlob = useCallback((file) => {
    setRecordedBlobFile(file);
  }, []);

  const resetRecording = useCallback(() => {
    setRecordedAudioFile(null);
    setRecordedBlobFile(null);
    setTranscript("");
  }, []);

  return {
    recordedAudioFile,
    setRecordedAudioFile,
    recordedBlobFile,
    transcript,
    setTranscript,
    transcriptLoading,
    setTranscriptLoading,
    disabledButton,
    setDisabledButton,
    handleRecordedBlob,
    resetRecording
  };
};
